import React from 'react';
import { connect } from 'react-redux';

const Events = props => {
  return (
    <div>
      Order events
    </div>
  );
};

export default connect()(Events);



// WEBPACK FOOTER //
// ./src/components/layout/content/orders/events.js